import React, { useEffect, useState } from 'react'
import { Grid, MenuItem, Select, Typography } from "@mui/material";
import { GrHomeRounded } from "react-icons/gr";
import { BsChatSquareText } from "react-icons/bs";
import { FaInfoCircle, FaGlobe } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import logo from './logo.png'
import logoFooter from './serendepia2.png'
import { SlTrophy } from "react-icons/sl";
import { TbLogout2 } from 'react-icons/tb';
import { AiOutlineSetting, AiOutlineUser } from 'react-icons/ai';
import { GrGallery } from 'react-icons/gr';

import './Layout.css'
import Auth from '../Auth/Auth';

function Layout(props) {
    const location = useLocation();
    const currentPath = location.pathname;
    const [user, setUser] = useState({});
    const [generalData, setGeneralData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showCommunityMenu, setShowCommunityMenu] = useState(false);
    const username = window.localStorage.getItem("username");
    useEffect(() => {

        const fetchData = async () => {
            try {
                const response = await fetch(`https://backmu.vercel.app/user/${username}`);
                const data = await response.json();
                setGeneralData(data);
            } catch (error) {
                console.error('Error fetching data:', error);
                setGeneralData(null);
            } finally {
                setIsLoading(false);
            }
        };

        if (username) {
            fetchData();
        }
    }, []);

    const [showPopupAuth, setShowPopupAuth] = useState(false);
    const [type, setType] = useState(0);
    const [lang, setLang] = useState("es");
    function togglePopupAuth(type) {
        setShowPopupAuth(!showPopupAuth);
        setType(type);
    }

    const handleLogout = async () => {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("_id");
        window.localStorage.removeItem("avatar");
        window.localStorage.removeItem("username");
        window.location.href = "/";
    };
    const [subMenu, setSubMenu] = useState(false);
    const [esClick, setEsClick] = useState(false);
    const [imagenes, setImagenes] = useState([])

    const habilitarSubMenu = (valor, e) => {
        if (e?.type === "click") {
            setEsClick(true);
        } else {
            setEsClick(false);
        }
        setTimeout(() => {
            setSubMenu(valor);
        }, [100]);
    };
    useEffect(() => {
        const handleClickOutside = () => {
            setSubMenu(false);
        };
        document.addEventListener("click", handleClickOutside);
        return () => {
            document.removeEventListener("click", handleClickOutside);
        };
    }, []);
    const dropdownTimeout = React.useRef(null);
    return (
        <Grid
            style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
                minHeight: '100vh',
                backgroundColor: '#080808',
                boxSizing: 'border-box',
                overflowX: 'hidden',
                overflowY: 'visible'
            }}
        >
            {/* TOP HEADER / NAVBAR */}
            <Grid
                className="premium-navbar"
                style={{
                    borderBottom: "1px solid #a5a7351c",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: props.isMobile ? "0px 1rem" : "1rem 5.8rem",
                    position: 'fixed',
                    top: 0,
                    zIndex: 999,
                    background: "linear-gradient(90deg, transparent, rgb(62 11 79 / 8%) 20%, rgb(138 22 139 / 12%) 50%, rgb(90 41 105 / 8%) 80%, transparent)",
                    width: "100%",
                    boxSizing: "border-box"
                }}
            >
                {/* Logo */}
                <Link to="/" style={{ width: props.isMobile ? '40%' : '12%', display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                    <img
                        src={logo}
                        style={{ width: "40%", objectFit: "contain" }}
                        alt="Logo"
                    />
                </Link>

                {/* Central Links (Desktop only) */}
                {!props.isMobile && (
                    <Grid style={{
                        display: 'flex',
                        gap: '15px',
                        alignItems: 'center',
                        position: 'relative',
                        overflow: 'visible'
                    }}>
                        <Link to="/" className="navbar-link" style={{ borderBottom: currentPath === '/' ? '2px solid #cd1009' : '2px solid transparent', paddingBottom: '4px' }}>INICIO</Link>
                        <Link
                            to="/informacion"
                            className="navbar-link"
                            style={{
                                borderBottom:
                                    currentPath === '/informacion'
                                        ? '2px solid #cd1009'
                                        : '2px solid transparent',

                                paddingBottom: '4px',

                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px'
                            }}
                        >
                            INFORMACIÓN

                        </Link>
                        <Link to="/rankings" className="navbar-link" style={{ borderBottom: currentPath === '/rankings' ? '2px solid #cd1009' : '2px solid transparent', paddingBottom: '4px' }}>RANKINGS</Link>
                        <Link to="/foro" className="navbar-link" style={{ borderBottom: currentPath === '/foro' ? '2px solid #cd1009' : '2px solid transparent', paddingBottom: '4px' }}>GUÍAS</Link>

                        <Link to="/descargas" className="navbar-link" style={{ borderBottom: currentPath === '/descargas' ? '2px solid #cd1009' : '2px solid transparent', paddingBottom: '4px' }}>DESCARGAS</Link>
                        <div
                            style={{

                                display: 'flex',
                                alignItems: 'center'
                            }}
                            onMouseEnter={() => {
                                clearTimeout(dropdownTimeout.current);
                                setShowCommunityMenu(true);
                            }}
                            onMouseLeave={() => {
                                dropdownTimeout.current = setTimeout(() => {
                                    setShowCommunityMenu(false);
                                }, 300);
                            }}
                        >
                            <Link
                                to="/informacion"
                                className="navbar-link"
                                style={{
                                    borderBottom:
                                        currentPath === '/informacion'
                                            ? '2px solid #cd1009'
                                            : '2px solid transparent',

                                    paddingBottom: '4px',

                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px'
                                }}
                            >
                                COMUNIDAD

                                <span
                                    style={{
                                        fontSize: '10px',
                                        opacity: .7,
                                        transition: '.2s ease',
                                        transform: showCommunityMenu
                                            ? 'rotate(180deg)'
                                            : 'rotate(0deg)'
                                    }}
                                >
                                    ▲
                                </span>
                            </Link>

                            {/* MENU */}
                            <div
                                onMouseEnter={() => {
                                    clearTimeout(dropdownTimeout.current);
                                    setShowCommunityMenu(true);
                                }}
                                onMouseLeave={() => {
                                    dropdownTimeout.current = setTimeout(() => {
                                        setShowCommunityMenu(false);
                                    }, 2000);
                                }}
                                style={{
                                    position: 'absolute',

                                    top: 'calc(100% + 12px)',
                                    right: 0,

                                    minWidth: '180px',

                                    background: '#111316',

                                    border: '1px solid #7c5c3e',
                                    borderRadius: '10px',

                                    padding: '8px 0',

                                    display: 'flex',
                                    flexDirection: 'column',

                                    zIndex: 999999,

                                    boxShadow: '0 12px 40px rgba(0,0,0,.45)',

                                    opacity: showCommunityMenu ? 1 : 0,

                                    visibility:
                                        showCommunityMenu
                                            ? 'visible'
                                            : 'hidden',

                                    transition: 'opacity .2s ease',

                                    pointerEvents:
                                        showCommunityMenu
                                            ? 'auto'
                                            : 'none'
                                }}
                            >
                                <Link
                                    to="/hof"
                                    style={{
                                        padding: '10px 14px',
                                        color: 'rgba(255,255,255,.82)',
                                        textDecoration: 'none',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    HoF
                                </Link>

                                <Link
                                    to="/videos"
                                    style={{
                                        padding: '10px 14px',
                                        color: 'rgba(255,255,255,.82)',
                                        textDecoration: 'none',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Videos
                                </Link>

                                <Link
                                    to="/streamers"
                                    style={{
                                        padding: '10px 14px',
                                        color: 'rgba(255,255,255,.82)',
                                        textDecoration: 'none',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    Streamers
                                </Link>
                            </div>
                        </div>
                    </Grid>
                )}

                {/* Auth and Server Status Indicators */}
                <Grid style={{ display: "flex", alignItems: "center" }}>
                    {/* Server Status Indicator (Desktop only) */}
                    {!props.isMobile && !isLoading && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', background: 'rgba(255,255,255,0.03)', padding: '0px 14px', borderRadius: '20px', border: '1px solid rgba(255,255,255,0.05)', marginRight: '20px', height: '2rem' }}>
                            {generalData && generalData.jugadoresOnline > 0 ? (
                                <>
                                    <span id="pulsatingDot" style={{ margin: 0 }} />
                                    <span style={{ color: '#1fff20', fontSize: '11px', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', fontFamily: 'Inter, sans-serif' }}>
                                        Online ({generalData.jugadoresOnline})
                                    </span>
                                </>
                            ) : (
                                <>
                                    <span id="pulsatingDotOff" style={{ margin: 0 }} />
                                    <span style={{ color: '#cd1009', fontSize: '11px', fontWeight: 700, letterSpacing: '0.05em', textTransform: 'uppercase', fontFamily: 'Inter, sans-serif' }}>
                                        Mantenimiento
                                    </span>
                                </>
                            )}
                        </div>
                    )}

                    {/* Selector de Idioma */}
                    <div
                        style={{
                            marginRight: '15px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px',
                            backgroundColor: "rgba(255, 255, 255, 0.05)",
                            borderRadius: "6px",
                            padding: "0px 12px",
                            border: "1px solid rgba(255, 255, 255, 0.1)"
                        }}
                    >
                        <FaGlobe
                            style={{
                                color: 'rgba(255, 255, 255, 0.75)',
                                fontSize: '14px'
                            }}
                        />

                        <Select
                            value={lang}
                            onChange={(e) => setLang(e.target.value)}
                            renderValue={(value) => ({
                                es: "ES",
                                en: "EN",
                                pt: "PT"
                            }[value])}
                            size='small'
                            sx={{
                                color: "white",
                                fontWeight: 600,
                                fontFamily: "Inter, sans-serif",
                                fontSize: "12px",
                                height: '2rem',
                                overflow: 'hidden',
                                width: "40px",

                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },

                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },

                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        mt: 1.5,
                                        minWidth: "180px",
                                        background: "#111316",
                                        border: "1px solid #7c5c3e",
                                        borderRadius: "10px",
                                        py: 1,
                                        boxShadow: "0 12px 40px rgba(0,0,0,.45)",

                                        "& .MuiMenuItem-root": {
                                            color: "#fff",
                                            fontSize: "14px",
                                            fontFamily: "Inter, sans-serif",
                                            minHeight: "40px",
                                        },

                                        "& .MuiMenuItem-root:hover": {
                                            backgroundColor: "rgba(124,92,62,.15)",
                                        },

                                        "& .MuiMenuItem-root.Mui-selected": {
                                            backgroundColor: "rgba(124,92,62,.25)",
                                        },

                                        "& .MuiMenuItem-root.Mui-selected:hover": {
                                            backgroundColor: "rgba(124,92,62,.35)",
                                        }
                                    }
                                }
                            }}
                        >
                            <MenuItem value="es">Español</MenuItem>
                            <MenuItem value="en">Inglés</MenuItem>
                            <MenuItem value="pt">Portugués</MenuItem>
                        </Select>
                    </div>

                    {!username ? (
                        <Grid style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <h6
                                onClick={() => togglePopupAuth(0)}
                                className="button-navbar-login"
                                style={{ margin: 0 }}
                            >
                                Ingresar
                            </h6>
                            <h6
                                onClick={() => togglePopupAuth(1)}
                                className="button-navbar-register"
                                style={{ margin: 0 }}
                            >
                                Registrarse
                            </h6>
                        </Grid>
                    ) : (
                        <Grid>
                            <div style={{ overflow: 'hidden' }}>


                                <div
                                    style={{
                                        width: "60px",
                                        height: "60px",
                                        position: "relative",
                                        overflow: 'hidden',
                                        backgroundColor: '#343843',
                                        borderRadius: "50%",
                                    }}
                                    className="navbar-image-avatar"
                                    onClick={(e) => habilitarSubMenu(true, e)}
                                    onMouseEnter={
                                        esClick
                                            ? console.log("activo")
                                            : () => habilitarSubMenu(true)
                                    }
                                    onMouseLeave={
                                        esClick
                                            ? console.log("activo")
                                            : () => habilitarSubMenu(false)
                                    }
                                >
                                    <img
                                        style={{ width: '100%' }}
                                        src={props.user?.Avatar ?? logo}
                                        alt=""
                                    />
                                </div>


                            </div>
                        </Grid>
                    )}
                </Grid>
            </Grid>
            {subMenu && (
                <Grid
                    onMouseEnter={
                        esClick
                            ? console.log("activo")
                            : () => habilitarSubMenu(true)
                    }
                    onMouseLeave={
                        esClick
                            ? console.log("activo")
                            : () => habilitarSubMenu(false)
                    }
                    style={{
                        backgroundColor: "#121418",
                        border: "1px solid #343843",
                        position: "absolute",
                        padding: "1rem",
                        width: "16.25rem",
                        right: props.isMobile ? '0' : "8%",
                        top: props.isMobile ? '10%' : "10%",
                        borderRadius: "0.5rem",
                        zIndex: 99999,
                    }}
                >
                    <Grid
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "15px",
                            marginTop: "15px",
                        }}
                    >
                        <Grid
                            style={{
                                backgroundColor: "#202329",
                                borderRadius: "5px",
                                display: "flex",
                                flexDirection: "column",
                                padding: "1rem",
                                width: "100%",
                            }}
                        >
                            <Grid
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "15px",
                                    padding: 10,
                                }}
                            >
                                <img
                                    src={props.user?.Avatar ?? logo}
                                    alt=""
                                    style={{
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "50%",
                                        objectFit: "cover",
                                    }}
                                />
                                <Grid
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "1px",
                                    }}
                                >
                                    <Link
                                        style={{
                                            textDecoration: "none",
                                            margin: 0,
                                            padding: 0,
                                        }}
                                        to={"/" + username}
                                    >
                                        <Typography
                                            style={{
                                                color: "white",
                                                fontSize: "1rem",
                                                fontFamily: "Inter",
                                                fontWeight: 600,
                                            }}
                                        >
                                            {username ?? "Usuario"}
                                        </Typography>
                                    </Link>

                                </Grid>
                            </Grid>
                        </Grid>
                        <Link
                            className="dropdownaccount-link"
                            to={"/" + username}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                textDecoration: 'none',
                                color: 'white'
                            }}
                        >
                            <AiOutlineUser style={{ marginRight: "10px" }} />
                            Mi Cuenta
                        </Link>
                        {/* <Link
                            className="dropdownaccount-link"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                            }}
                            to={"/" + user?.username + "/galeria"}
                        >
                            <GrGallery style={{ marginRight: "10px" }} />
                            Galeria
                        </Link> */}
                        <Link
                            className="dropdownaccount-link"
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                textDecoration: 'none',
                                color: 'white'
                            }}
                            to={"/" + username + "/settings"}
                        >
                            <AiOutlineSetting style={{ marginRight: "10px" }} />
                            Configuración
                        </Link>
                        <div
                            className="dropdownaccount-link"
                            onClick={() => handleLogout()}
                            style={{ display: "flex", alignItems: 'center' }}
                        >
                            <TbLogout2 style={{ marginRight: "10px", color: 'white' }} />
                            <Typography style={{ color: 'white' }}>
                                Cerrar sesión
                            </Typography>
                        </div>
                    </Grid>
                </Grid>
            )}
            {/* MAIN CONTENT */}
            <Grid style={{ width: "100%", flex: 1, display: "flex", flexDirection: "column", justifyContent: 'center' }}>
                {React.Children.map(props.children, child => {
                    if (React.isValidElement(child)) {
                        return React.cloneElement(child, {
                            openAuthPopup: (type) => togglePopupAuth(type)
                        });
                    }
                    return child;
                })}

                {showPopupAuth === true && (
                    <Auth
                        isMobile={props.isMobile}
                        typeDefault={type}
                        closePopup={() => togglePopupAuth()}
                    />
                )}
            </Grid>

            {/* MOBILE MENU (Bottom bar for mobile) */}
            {props.isMobile && (
                <div className="mobile-menu">
                    <Grid style={{ borderRight: '1px solid #2a2e38', display: 'flex', flex: '1 1', justifyContent: 'center', height: '100%' }}>
                        <Link style={{ textDecoration: "none", margin: '0 auto', padding: '10px 0px' }} to="/">
                            <Grid style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}>
                                <GrHomeRounded style={{ fontSize: '14px', color: currentPath === '/' ? '#cd1009' : 'white' }} />
                                <span style={{ fontSize: '14px', color: currentPath === '/' ? '#cd1009' : 'white', borderBottom: currentPath === '/' ? '2px solid #cd1009' : '2px solid transparent' }}>Inicio</span>
                            </Grid>
                        </Link>
                    </Grid>

                    <Grid style={{ borderRight: '1px solid #2a2e38', display: 'flex', flex: '1 1', justifyContent: 'center', height: '100%' }}>
                        <Link style={{ textDecoration: "none", margin: '0 auto', padding: '10px 0px' }} to="/rankings">
                            <Grid style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}>
                                <SlTrophy style={{ fontSize: '14px', color: currentPath === '/rankings' ? '#cd1009' : 'white' }} />
                                <span style={{ fontSize: '14px', color: currentPath === '/rankings' ? '#cd1009' : 'white', borderBottom: currentPath === '/rankings' ? '2px solid #cd1009' : '2px solid transparent' }}>Rankings</span>
                            </Grid>
                        </Link>
                    </Grid>

                    <Grid style={{ borderRight: '1px solid #2a2e38', display: 'flex', flex: '1 1', justifyContent: 'center', height: '100%' }}>
                        <Link style={{ textDecoration: "none", margin: '0 auto', padding: '10px 0px' }} to="/foro">
                            <Grid style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}>
                                <BsChatSquareText style={{ fontSize: '14px', color: currentPath === '/foro' ? '#cd1009' : 'white' }} />
                                <span style={{ fontSize: '14px', color: currentPath === '/foro' ? '#cd1009' : 'white', borderBottom: currentPath === '/foro' ? '2px solid #cd1009' : '2px solid transparent' }}>Foro</span>
                            </Grid>
                        </Link>
                    </Grid>

                    <Grid style={{ display: 'flex', flex: '1 1', justifyContent: 'center', height: '100%' }}>
                        <Link style={{ textDecoration: "none", margin: '0 auto', padding: '10px 0px' }} to="/informacion">
                            <Grid style={{ display: 'flex', flexDirection: 'column', gap: '5px', alignItems: 'center' }}>
                                <FaInfoCircle style={{ fontSize: '14px', color: currentPath === '/informacion' ? '#cd1009' : 'white' }} />
                                <span style={{ fontSize: '14px', color: currentPath === '/informacion' ? '#cd1009' : 'white', borderBottom: currentPath === '/informacion' ? '2px solid #cd1009' : '2px solid transparent' }}>Información</span>
                            </Grid>
                        </Link>
                    </Grid>
                </div>
            )}

            {/* FOOTER */}
            <Grid style={{
                width: '100%',
                display: "flex",
                flexDirection: "column",
                padding: props.isMobile ? "2rem 1rem" : "3rem 5.8rem",
                backgroundColor: "rgb(18, 20, 24)",
                gap: '2rem',
                boxSizing: 'border-box'
            }}>
                <Grid style={{ display: 'flex', alignItems: 'flex-start', width: '100%', flexDirection: props.isMobile ? 'column' : 'row', gap: props.isMobile ? '1.5rem' : '0px' }}>
                    {/* COLUMNA LOGO */}
                    <Grid style={{ width: props.isMobile ? '100%' : "20%" }}>
                        <Link to="/" style={{ margin: props.isMobile ? '0 auto' : '0', display: 'flex', justifyContent: props.isMobile ? 'center' : 'flex-start' }}>
                            <img
                                src={logo}
                                style={{ width: props.isMobile ? '40%' : "60%", maxHeight: "80px", objectFit: "contain" }}
                                alt=""
                            />
                        </Link>
                    </Grid>
                    {/* COLUMNA SUPPORT */}
                    <Grid style={{ display: 'flex', alignItems: props.isMobile ? 'center' : 'flex-start', flexDirection: 'column', justifyContent: 'center', width: props.isMobile ? '100%' : '20%', color: 'white', textAlign: props.isMobile ? 'center' : 'left' }}>
                        <Typography style={{ fontWeight: 800, fontSize: '1rem', textShadow: '0 1px 0 #000', marginBottom: '8px' }}>Soporte</Typography>
                        <Typography style={{ color: '#828998', fontFamily: 'Inter', fontSize: '14px', cursor: 'pointer' }}>Soporte en Vivo</Typography>
                        <Typography style={{ color: '#828998', fontFamily: 'Inter', fontSize: '14px', cursor: 'pointer' }}>Centro de Ayuda</Typography>
                        <Typography style={{ color: '#828998', fontFamily: 'Inter', fontSize: '14px', cursor: 'pointer' }}>Juego Responsable</Typography>
                    </Grid>
                    {/* COLUMNA PLATFORM */}
                    <Grid style={{ display: 'flex', alignItems: props.isMobile ? 'center' : 'flex-start', flexDirection: 'column', justifyContent: 'center', width: props.isMobile ? '100%' : '20%', color: 'white', textAlign: props.isMobile ? 'center' : 'left' }}>
                        <Typography style={{ fontWeight: 800, fontSize: '1rem', textShadow: '0 1px 0 #000', marginBottom: '8px' }}>Plataforma</Typography>
                        <Link to="/descargas" style={{ color: '#828998', textDecoration: 'none', fontFamily: 'Inter', fontSize: '14px' }}>Descargas</Link>
                        <Link to="/rankings" style={{ color: '#828998', textDecoration: 'none', fontFamily: 'Inter', fontSize: '14px' }}>Clasificaciones</Link>
                        <Link to="/foro" style={{ color: '#828998', textDecoration: 'none', fontFamily: 'Inter', fontSize: '14px' }}>Foro de Discusión</Link>
                    </Grid>
                    {/* COLUMNA POLICY */}
                    <Grid style={{ display: 'flex', alignItems: props.isMobile ? 'center' : 'flex-start', flexDirection: 'column', justifyContent: 'center', width: props.isMobile ? '100%' : '20%', color: 'white', textAlign: props.isMobile ? 'center' : 'left' }}>
                        <Typography style={{ fontWeight: 800, fontSize: '1rem', textShadow: '0 1px 0 #000', marginBottom: '8px' }}>Políticas</Typography>
                        <Typography style={{ color: '#828998', fontFamily: 'Inter', fontSize: '14px', cursor: 'pointer' }}>Términos de Servicio</Typography>
                        <Typography style={{ color: '#828998', fontFamily: 'Inter', fontSize: '14px', cursor: 'pointer' }}>Política de Privacidad</Typography>
                        <Typography style={{ color: '#828998', fontFamily: 'Inter', fontSize: '14px', cursor: 'pointer' }}>Reglas del Servidor</Typography>
                    </Grid>
                    {/* COLUMNA COMMUNITY */}
                    <Grid style={{ display: 'flex', alignItems: props.isMobile ? 'center' : 'flex-start', flexDirection: 'column', justifyContent: 'center', width: props.isMobile ? '100%' : '20%', color: 'white', textAlign: props.isMobile ? 'center' : 'left' }}>
                        <Typography style={{ fontWeight: 800, fontSize: '1rem', textShadow: '0 1px 0 #000', marginBottom: '8px' }}>Comunidad</Typography>
                        <Typography style={{ color: '#828998', fontFamily: 'Inter', fontSize: '14px', cursor: 'pointer' }}>Discord Oficial</Typography>
                        <Typography style={{ color: '#828998', fontFamily: 'Inter', fontSize: '14px', cursor: 'pointer' }}>Facebook</Typography>
                        <Typography style={{ color: '#828998', fontFamily: 'Inter', fontSize: '14px', cursor: 'pointer' }}>Instagram</Typography>
                    </Grid>
                    {/* IDIOMA */}
                    {/* <Grid
                        style={{
                            display: "flex",
                            alignItems: props.isMobile ? "center" : "flex-start",
                            flexDirection: "column",
                            justifyContent: "center",
                            width: props.isMobile ? '60%' : "10%",
                            color: "white",
                        }}
                    >
                        <select
                            style={{
                                width: "100%",
                                height: "100%",
                                backgroundColor: "#2a2e38",
                                borderRadius: "5px",
                                color: "white",
                                padding: "10px",
                                border: "1px solid #343843"
                            }}
                            name="lang"
                            id="lang"
                        >
                            <option value="es"> Español</option>
                            <option value="en"> Inglés</option>
                        </select>
                    </Grid> */}
                </Grid>
            </Grid>
        </Grid>
    );
}

export default Layout